<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-9">
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--80 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="mb-4">
                <h2>Войти</h2>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="Почта"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Пароль"
                              v-model="model.password">
                  </base-input>

                  <b-form-checkbox v-model="model.rememberMe">Запомнить</b-form-checkbox>
                  <div class="text-right">
                    <base-button type="primary" native-type="submit" class="mt-4 vs-con-loading__container">Войти <span
                      v-show="loading" id="loading-container"></span></base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/register" class="text-light"><small>Создать новый аккаунт</small></router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from 'axios'

export default {
  data() {
    return {
      loading: false,
      backgroundLoading: 'transparent',
      colorLoading: '#fff',
      model: {
        email: '',
        password: '',
        rememberMe: false
      }
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  watch: {
    currentUser() {
      this.$router.push({name: 'dashboard'});
    }
  },
  methods: {
    async onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
      this.loading = true
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#loading-container',
        scale: 0.45
      })
      const response = await axios
        .post("login", {
          email: this.model.email,
          password: this.model.password,
        }).finally(() => this.loading = false, this.$vs.loading.close('#loading-container > .con-vs-loading'));

      localStorage.setItem("token", response.data.token);
      const token = localStorage.getItem('token');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      this.$store.dispatch("fetchUser");
      // this.$router.go(this.$router.currentRoute);
    }
  }
};
</script>

<style scoped>
#loading-container {
  width: 15px;
  margin-left: 10px;
  display: inherit;
  position: relative;
  bottom: 5px
}

h2 {
  font-size: 24px;
  color: #32325d;
}

.mt--80 {
  margin-top: -18rem;
}

@media only screen and (max-width: 600px) {
  .mt--80 {
    margin-top: -12rem;
  }
}
</style>
